import * as React from "react";
import usePluginEntities from "hooks/usePluginEntities";
import InputsDotBadge from "./InputsDotBadge";
const useInputsBadgeProviderResults = () => {
  const providers = usePluginEntities("inputsBadgeProviders");
  return providers.map((provider) => provider.useCondition());
};
const InputsAggregatedDotBadge = ({ text }) => {
  const providerResults = useInputsBadgeProviderResults();
  const providerIssue = providerResults.find((r) => r.hasIssues);
  return /* @__PURE__ */ React.createElement(InputsDotBadge, { text, hasExternalIssues: !!providerIssue, externalIssuesTitle: providerIssue == null ? void 0 : providerIssue.title });
};
export default InputsAggregatedDotBadge;
